import * as React from "react";
import { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Document } from "react-pdf";
import { Page } from "react-pdf";
import classes from "./ViewPatientsResponsibility.module.css";
import { withTranslation } from "react-i18next";
// import { useTranslation,withTranslation } from 'react-i18next';

interface IParentProps {
  viewBillNumber: number;
  closeViewing: () => void;
}

interface IStateFromProps {
  patientsResponsibilityBills: File[];
  t:any;
}

type Props = IParentProps & IStateFromProps;
class ViewPatientsResponsibility extends Component<Props> {
  state = {
    url: this.props.patientsResponsibilityBills[this.props.viewBillNumber],
    numPages: null,
  };
  viewingBillsHandler = (index: number) => {
    console.log("viewbills", index);
    this.setState({ url: this.props.patientsResponsibilityBills[index] });
  };
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };
  render() {
    const {t} = this.props;
    const { closeViewing } = { ...this.props };
    const { numPages } = this.state;
    return (
      <Fragment>
        <div className="popupHeader">
          <h6>{t('balanceBills.viewBills')}</h6>
          <div className="closeBtn" onClick={closeViewing}>
            X
          </div>
        </div>

        <div className={classes.popupBody}>
          <div className={classes.imgBody}>
            {this.state.url &&
              (this.state.url.name.includes("pdf") ? (
                <Document
                  file={this.state.url}
                  onLoadSuccess={this.onDocumentLoadSuccess}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                  ))}
                  {/* <Page pageNumber={1} /> */}
                </Document>
              ) : (
                <img src={URL.createObjectURL(this.state.url)} alt="..." />
              ))}
          </div>
          <div className={classes.uploadPreview}>
            {(this.props.patientsResponsibilityBills || []).map(
              (url, index) => (
                <div className={classes.uploadPreviewImg} key={`file${index}`}>
                  <div
                    className={[
                      classes.previewThumb,
                      classes.thumbSelected,
                    ].join(" ")}
                  >
                    {url.name.includes("pdf") ? (
                      <Document file={url}>
                        <Page
                          pageNumber={1}
                          onClick={() => this.viewingBillsHandler(index)}
                        />
                      </Document>
                    ) : (
                      <img
                        src={URL.createObjectURL(url)}
                        alt="..."
                        onClick={() => this.viewingBillsHandler(index)}
                      />
                    )}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  patientsResponsibilityBills: state.browseImages.patientsResponsibilityBills,
});
export default connect(mapStateToProps)(withTranslation()(ViewPatientsResponsibility));
// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ViewPatientsResponsibility));
